"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { COLORS } from "./chartColors";
import { sortLabelsChronologically, formatMonthlyLabel } from "./helpers/dateHelpers";
import { groupByPeriodAndKey } from "./helpers/dataGroupingHelpers";
const ALLOWED_TYPES = ["Internal", "External"];
export const jobCountInternalExternalTransformer = (data, selectedEntities) => {
  const allRecords = [];
  Object.entries(data).forEach(([key, value]) => {
    let monthLabel;
    if (key.startsWith("Q")) {
      monthLabel = key;
    } else {
      const [entity_id, year, month] = key.split("_");
      monthLabel = month && year ? formatMonthlyLabel(parseInt(month), parseInt(year)) : key;
    }
    const isAllSelected = selectedEntities == null ? void 0 : selectedEntities.some((entity) => entity.name === "All");
    const isEntitySelected = selectedEntities == null ? void 0 : selectedEntities.some(
      (entity) => entity.id.toString() === (key.startsWith("Q") ? key.split("_")[0] : key.split("_")[0])
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        const isInternal = record.internal === true || record.internal === "true" || record.internal === "1";
        const isExternal = record.external === true || record.external === "true" || record.external === "1";
        let type = null;
        if (isInternal && !isExternal) {
          type = "Internal";
        } else if (!isInternal && isExternal) {
          type = "External";
        } else {
          type = null;
        }
        if (!type) return;
        allRecords.push(__spreadProps(__spreadValues({}, record), { _periodLabel: monthLabel, _type: type }));
      });
    }
  });
  const monthlyTypeCounts = groupByPeriodAndKey(
    allRecords,
    (record) => record._periodLabel,
    (record) => record._type || "Unknown"
  );
  const sortedLabels = sortLabelsChronologically(Object.keys(monthlyTypeCounts));
  const datasets = ALLOWED_TYPES.map((type, index) => ({
    label: type,
    data: sortedLabels.map((label) => monthlyTypeCounts[label][type] || 0),
    backgroundColor: COLORS[index % COLORS.length],
    borderWidth: 1,
    stack: "jobTypes"
  }));
  return {
    labels: sortedLabels,
    datasets
  };
};
